import React from 'react';
import MetricsCards from './MetricsCards';
import AnalyticsChart from './AnalyticsChart';
import { AnalyticsData, ChartData } from '../types';

interface PageViewAnalyticsContainerProps {
  timePeriod: string;
  groupBy: string;
  analyticsData: AnalyticsData | null;
  chartData: ChartData[];
}

const PageViewAnalyticsContainer: React.FC<PageViewAnalyticsContainerProps> = ({ 
  timePeriod, 
  groupBy,
  analyticsData,
  chartData
}) => {
  return (
    <div className="space-y-4">
      {/* Metrics Cards */}
      <MetricsCards analyticsData={analyticsData} />

      {/* Chart */}
      <AnalyticsChart 
        timePeriod={timePeriod} 
        groupBy={groupBy} 
        chartData={chartData}
      />
    </div>
  );
};

export default PageViewAnalyticsContainer;
